interface DragItHere {
  hoverPos: "top" | "bottom"
}

export default ({ hoverPos, dragHovering }: DragItHere) => {
  return (
    <div style={{opacity: dragHovering ? 1 : 0,}}>
      <div
        style={{
          position: "absolute",
          [hoverPos]: 0,
          outline: "2px solid #fc679a",
          left: 0,
          zIndex: 2,
          right: 0,
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          [hoverPos]: -11,
          textAlign: "center",
          zIndex: 2,
          left: 0,
          right: 0,
        }}
      >
        <div
          style={{
            backgroundColor: "#fc679a",
            borderRadius: 9,
            padding: "0 8px",
            display: "inline-block",
            color: "white",
          }}
        >
          Drag it here
        </div>
      </div>
    </div>
  );
}
